import styled from 'styled-components';
import { Box } from 'grid-styled';
import { color } from 'styled-system';

export const BoxTemplate = styled(Box)`
    ${color};
    display: ${props => props.display};
    padding-top: 3px;
    padding-bottom: 3px;
    vertical-align: top;
    min-height: ${props => props.minheight};
    border: ${props => props.border};
    position: ${props => props.position};
    text-align: ${props => props.textalign};
`;



// WEBPACK FOOTER //
// ./src/styledSystem/Box.js